export default {
    BusinessPurchaseCostDown: {
        number: '合同编号',
        BasePrice: '基准价',
        price: '采购单价',
        amount: '采购金额',
        Cost: '降本金额',
        time: '采购时间',
        statistics: '是否参与成本统计',
        Total: '降本总金额',
        Base: '基准日期',
        Calculate: '核算日期',
        The: '基准日期不能大于等于核算日期',
        purchaser: '采购员',
        Assessment: '考核月份',
        SKUs: 'SKU总数',
        ignored: '已忽略sku数量',
        notIgnored: '未忽略sku数量',
        Aquantity: 'A级数量',
        Bquantity: 'B级数量',
        completedA: 'A级完成数量',
        completedB: 'B级完成数量',
        ERPA: 'A级ERP完成数量',
        ERPB: 'B级ERP完成数量',
        TimelinessA: 'A级返单及时率',
        TimelinessB: 'B级返单及时率',
        TimelinessERPA: 'A级ERP返单及时率',
        TimelinessERPB: 'B级ERP返单及时率',
        Timeliness: '总返单及时率',
        TimelinessERP: 'ERP总返单及时率',
        exportDetail: '导出详情'
    }
  };
